<script setup lang="ts">
const { data: queriedConfig } = await useAsyncData('config-data', () =>
  queryCollection('config').first(),
);

const config = useState('CONTENT_CONFIG', () => queriedConfig.value);

const lang = useLocalStorage('CONTENT_LANG', 'en');

useHead({
  htmlAttrs: {
    lang: lang.value,
  },
  link: [{ rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' }],
  bodyAttrs: {
    class: 'light',
  },
});
</script>

<template>
  <div
    data-theme="light"
    class="light"
    :style="{ backgroundColor: 'var(--color-white)' }"
  >
    <MarketingTags />
    <ContentLayout
      :headerThemeKeys="{
        bg: 'var(--color-white)',
        text: 'var(--color-slate-700)',
        login: 'var(--color-cantook-blue-500)',
        signUpBg: 'var(--color-cantook-blue-500)',
        signUpFg: 'var(--color-white)',
      }"
      :footerThemeKeys="{
        bgBottom: 'var(--color-neutral-800)',
        fgBottom: 'var(--color-white)',
      }"
      :links="{
        logo: '/',
        pricing: '/pricing',
        features: '/features',
        resources: '/resources',
        login: '/login',
        signup: '/login',
      }"
    >
      <div v-if="queriedConfig">
        <slot />
      </div>
    </ContentLayout>
  </div>
</template>

<style>
h1, h2, h3, h4, h5 {
  font-family: "Poppins";
}
</style>
